import { FC, ReactNode } from 'react';
import { AIIcon, IconComponent } from '../../theme/Icons';
import { Text } from '../../components/Text';
import { SelectableText } from '../../components/SelectableText';

export const BulletList: React.FC<{ heading: string, items?: string[] }> = ({ heading, items }) => {
    if (items?.length && Array.isArray(items)) {
        return (
            <div style={{marginBottom: 12}}>
                <SelectableText>
                    <b>{heading}</b>
                    <ul style={{margin: 0}}>
                        {items!.map((item, idx) => (<li key={`item-${idx}`}>{item}</li>))}
                    </ul>
                </SelectableText>
            </div>
        );
    }
};

export type IViewNoteHeadingProps = {
    title: string;
    Icon: IconComponent;
    showAIIcon?: boolean;
    actionLink?: {
        text: string;
        onClick: () => void;
    };
};

const ViewNoteHeading: FC<IViewNoteHeadingProps> = ({ title, Icon, showAIIcon, actionLink }) => {
    return (
        <div style={{display: 'flex', gap: 6, marginBottom: 8, alignItems: 'center', justifyContent: 'space-between'}}>
            <div style={{display: 'flex', gap: 6, alignItems: 'center'}}>
                <Icon color="medium" />
                <Text type="subtitle"><span style={{color: 'var(--ion-color-step-600)'}}>{title}</span></Text>
                {showAIIcon && <AIIcon color="primary" />}
            </div>
            {actionLink && (
                <span
                    onClick={actionLink.onClick}
                    style={{
                        color: 'var(--ion-color-primary)',
                        fontSize: '14px',
                        cursor: 'pointer',
                        fontWeight: 500
                    }}
                    data-id="section-action-link"
                >
                    {actionLink.text}
                </span>
            )}
        </div>
    );
};

export const ViewNoteSection: FC<IViewNoteHeadingProps & { children: ReactNode; 'data-id'?: string; }> = ({ title, Icon, children, showAIIcon, actionLink, 'data-id': dataId }) => {
    return (
        <div style={{marginTop: 12, marginBottom: 16}} data-id={dataId}>
            <ViewNoteHeading title={title} Icon={Icon} showAIIcon={showAIIcon} actionLink={actionLink} />
            {children}
        </div>
    );
};
